export const translations = {
  ru: {
    nav: {
      about: 'О франшизе',
      format: 'Формат',
      finances: 'Финансы',
      investments: 'Инвестиции',
      gallery: 'Галерея',
      contacts: 'Связаться сейчас',
      call: 'Связаться',
    },
    hero: {
      tag: 'Инвестиционная возможность',
      title_line1: 'Стабильный бизнес,',
      title_line2: 'который растёт',
      brand: 'KidsMafia',
      subtitle: 'Готовая модель семейного event-бизнеса с окупаемостью 23–25 месяцев',
      metric1_label: 'Маржинальность до',
      metric1_value: 40,
      metric1_suffix: '%',
      metric1_unit: '',
      metric2_label: 'Окупаемость от',
      metric2_value: 23,
      metric2_suffix: ' мес',
      metric3_label: 'Инвестиции от',
      metric3_value: 150000,
      metric3_suffix: ' €',
      cta_call: 'Связаться',
      cta_presentation: 'Получить презентацию',
      cta_telegram: 'Написать в Telegram',
      scroll_hint: 'Узнать больше',
    },
    about: {
      title: 'Что такое KidsMafia',
      desc1: 'KidsMafia — это семейное event-пространство полного цикла.',
      desc2: 'Пространство, где дети празднуют, родители отдыхают, а команда полностью организует мероприятие.',
      features: [
        { title: 'Детский парк', desc: 'Современные аттракционы и игровые зоны' },
        { title: 'Ресторанная зона', desc: 'Полноценный ресторан для всей семьи' },
        { title: 'Event-пространство', desc: 'Площадка для проведения мероприятий' },
        { title: 'Профессиональная анимация', desc: 'Аниматоры и шоу-программы' },
        { title: 'Мероприятия под ключ', desc: 'Полная организация от А до Я' },
        { title: 'Сопровождение детей', desc: 'Профессиональный уход и присмотр' },
        { title: 'Банкетные форматы', desc: 'Банкеты и корпоративные события' },
        { title: 'Выездные мероприятия', desc: 'Организация событий за пределами площадки' },
      ],
    },
    format: {
      title: 'Единая система семейных мероприятий',
      subtitle: 'Пять ключевых направлений в рамках одного пространства',
      items: [
        { title: 'Детский парк развлечений', desc: 'Современные аттракционы, горки, батуты, мягкие площадки' },
        { title: 'Ресторанная зона', desc: 'Полноценный ресторан с детским меню и банкетными предложениями' },
        { title: 'Event-пространство', desc: 'Трансформируемые залы для любых форматов мероприятий' },
        { title: 'Организация мероприятий', desc: 'Праздники под ключ: декор, анимация, фото, кейтеринг' },
        { title: 'Сервис присмотра за детьми', desc: 'Профессиональные воспитатели и аниматоры' },
      ],
    },
    franchiseFormats: {
      title: 'Форматы франшизы',
      subtitle: 'Три формата входа в бизнес под разный бюджет и масштаб',
      standard: {
        type: 'STANDARD',
        area: '250–300 м²',
        label1: 'Мероприятий в месяц',
        val1: '20–40',
        label2: 'Оборот',
        val2: '18 000 – 40 000 €',
        label3: 'Маржинальность',
        val3: '25–35%',
        badge: 'Старт в бизнесе',
        desc: 'Включает парк, ресторан и event-зону',
      },
      recommended: {
        type: 'РЕКОМЕНДОВАННЫЙ',
        area: '300–600 м²',
        label1: 'Мероприятий в месяц',
        val1: '30–50',
        label2: 'Оборот',
        val2: '35 000 – 50 000 €',
        label3: 'Маржинальность',
        val3: '30–40%',
        badge: 'Оптимальный выбор',
        desc: 'Расширенная event-зона и больше возможностей',
      },
      premium: {
        type: 'PREMIUM',
        area: '600+ м²',
        label1: 'Мероприятий в месяц',
        val1: '40–70',
        label2: 'Оборот',
        val2: '50 000 – 70 000 €',
        label3: 'Маржинальность',
        val3: '35–45%',
        badge: 'Масштабный формат',
        desc: 'Полный комплекс с зоной мастер-классов',
      },
    },
    investments: {
      title: 'Инвестиции в открытие',
      subtitle: 'Прозрачная структура затрат',
      items: [
        { label: 'Трансфер и лицензии', value: '25 000 – 60 000 €', icon: 'FileCheck' },
        { label: 'Ремонт и отделка', value: '20 000 – 40 000 €', icon: 'Wrench' },
        { label: 'Оборудование и декор', value: '15 000 – 30 000 €', icon: 'Package' },
        { label: 'Оборотный капитал', value: '40 000 – 50 000 €', icon: 'Banknote' },
      ],
      total_label: 'Общие инвестиции',
      total_value: 'от 150 000 €',
      total_note: 'Полный пакет поддержки при открытии',
    },
    franchiseIncludes: {
      title: 'Что входит в паушальный взнос',
      subtitle: 'Полный запуск бизнеса под ключ',
      priceLabel: 'Паушальный взнос',
      priceValue: '40 000 €',
      priceNote: 'Единый паушальный взнос для всех форматов. Формат влияет на объём инвестиций и масштаб проекта.',
      paymentsTitle: 'Регулярные платежи',
      royalty: {
        label: 'Роялти',
        year1: '1-й год — 5%',
        year2plus: 'со 2-го года — 6–8%',
      },
      marketingFee: {
        label: 'Маркетинговый сбор',
        value: '1–2%',
      },
      block1: {
        title: 'Основа бизнеса',
        items: [
          'Право использования бренда KidsMafia',
          'Готовая бизнес-модель',
          'Финансовая модель с расчетами',
          'Инвестиционный план запуска',
          'Дизайн-гайд и стандарты оформления',
        ],
      },
      block2: {
        title: 'Операционная система',
        items: [
          'Операционные регламенты',
          'Стандарты сервиса',
          'Стандарты анимации',
          'Тайминг мероприятий',
          'Чек-листы ежедневного контроля',
        ],
      },
      block3: {
        title: 'Кухня и бар',
        items: [
          'Технологические карты кухни',
          'Запуск кухни под ключ',
          'Формирование меню',
          'Формирование меню бара',
          'Калькуляция себестоимости',
        ],
      },
      block4: {
        title: 'Запуск под ключ',
        items: [
          'Полный запуск проекта',
          'Поддержка на всех этапах',
          'Сценарии мероприятий',
          'Форматы праздников',
          'Дополнительные программы',
        ],
      },
      revenueTitle: 'Дополнительные источники дохода',
      revenueSources: [
        'Дни рождения',
        'Ресторан',
        'Игровая зона',
        'Мастер-классы',
        'Квесты',
        'Тематические вечеринки',
        'Выездные мероприятия',
        'Сезонные программы',
      ],
    },
    revenue: {
      title: 'Как зарабатывает бизнес',
      subtitle: 'Множество источников дохода в рамках одного пространства',
      items: [
        { label: 'Дни рождения', icon: 'Gift' },
        { label: 'Ресторан', icon: 'Utensils' },
        { label: 'Свободное посещение', icon: 'DoorOpen' },
        { label: 'Мастер-классы', icon: 'Palette' },
        { label: 'Квесты', icon: 'Search' },
        { label: 'Тематические вечеринки', icon: 'PartyPopper' },
        { label: 'Выездные мероприятия', icon: 'Car' },
        { label: 'Сезонные программы', icon: 'Calendar' },
        { label: 'Клуб выходного дня', icon: 'Coffee' },
        { label: 'Садик неполного дня', icon: 'Baby' },
        { label: 'Услуги няни', icon: 'Heart' },
        { label: 'Образовательные встречи', icon: 'BookOpen' },
      ],
    },
    financial: {
      title: 'Финансовая модель',
      subtitle: 'Понятные цифры — прозрачный бизнес',
      metrics: [
        { label: 'Минимальный чек праздника', value: '400 €', num: 400 },
        { label: 'Средний чек', value: '700 €', num: 700 },
        { label: 'Средний оборот / месяц', value: '25 000 €', num: 25000 },
        { label: 'Чистая прибыль', value: '≈ 6 000 €', num: 6000 },
      ],
      note1: 'Для покрытия фиксированных расходов достаточно около 10 мероприятий в месяц.',
      note2: 'Средняя загрузка составляет 20–35 мероприятий.',
      detailsTitle: 'Детальная разбивка',
      revenueBreakdown: {
        title: 'Структура дохода',
        items: [
          { label: 'Дни рождения', percent: '60%' },
          { label: 'Ресторан', percent: '20%' },
          { label: 'Игровая зона', percent: '20%' },
        ],
      },
      expensesBreakdown: {
        title: 'Структура расходов',
        fixed: [
          'Аренда помещения',
          'Зарплата персонала',
          'Коммунальные услуги',
          'Роялти',
        ],
        variable: [
          'Продукты (ресторан)',
          'Расходные материалы',
          'Реклама',
        ],
      },
      paybackTitle: 'Окупаемость',
      paybackValue: '≈ 25 месяцев',
    },
    scaling: {
      title: 'Масштабирование бизнеса',
      subtitle: 'От одной точки до национальной сети',
      items: [
        { title: 'Одна точка', desc: 'Ваш первый шаг в семейный бизнес', num: '01' },
        { title: 'Несколько точек в городе', desc: 'Расширение присутствия и доли рынка', num: '02' },
        { title: 'Эксклюзив на город', desc: 'Монопольное право на работу в городе', num: '03' },
        { title: 'Эксклюзив на регион', desc: 'Региональный охват и управление сетью', num: '04' },
        { title: 'Master-франшиза страны', desc: 'Управление всей национальной сетью', num: '05' },
      ],
    },
    gallery: {
      title: 'Галерея',
      subtitle: 'Атмосфера, которая продаёт',
    },
    investorMarket: {
      title: 'Почему инвесторы заходят в этот рынок',
      subtitle: 'Стабильный спрос и устойчивость к кризисам',
      reasons: [
        'Дети рождаются постоянно',
        'Дни рождения не отменяются',
        'Родители продолжают тратить на детей даже в кризис',
        'Семейный досуг постоянно растёт',
      ],
      antiCrisis: {
        title: 'Антикризисность рынка',
        reduce: 'В сложные времена люди сокращают',
        reduceList: [
          'Дорогие поездки',
          'Luxury-покупки',
          'Крупные необязательные расходы',
        ],
        continue: 'Но продолжают тратить на',
        continueList: [
          'Дни рождения детей',
          'Семейный досуг',
          'Развлечения для ребёнка',
          'Эмоции и праздники',
        ],
      },
      investorGets: {
        title: 'Что получает инвестор',
        list: [
          'Долю в прибыльной модели',
          'Прозрачную бизнес-систему',
          'Участие в прибыли',
          'Рост стоимости актива',
          'Понятный сценарий выхода',
        ],
      },
    },
    investorExit: {
      title: 'Стратегия выхода инвестора',
      subtitle: 'Гибкие варианты монетизации инвестиций',
      options: [
        'Продать точку как готовый бизнес',
        'Продать франшизу',
        'Продать долю',
      ],
      valuation: {
        label: 'Средняя оценка действующей точки',
        value: '≈ 250 000 €',
      },
      explanation: 'Это означает, что инвестор может вернуть вложенные средства и заработать на росте стоимости бизнеса.',
    },
    franchiseGoals: {
      title: 'Цель франшизы',
      subtitle: 'Глобальное развитие сети',
      goals: [
        'Масштабирование в странах ЕС',
        'Выход на рынки США и Азии',
        'Создание международной сети',
      ],
      detailsTitle: 'Детали стратегии',
      detailsList: [
        'Адаптация модели под местные рынки',
        'Поиск региональных мастер-франчайзи',
        'Системное расширение присутствия',
        'Построение узнаваемого бренда',
      ],
    },
    partnerRequirements: {
      title: 'Требования к партнёру',
      visibleTitle: 'Минимальные требования',
      capital: 'Капитал: от 120 000 €',
      detailsTitle: 'Важные условия',
      requirements: [
        'Соблюдение стандартов бренда',
        'Работа по установленной системе',
        'Опыт в бизнесе не обязателен',
        'Желание развивать проект',
        'Готовность инвестировать в обучение',
      ],
    },
    whyDifferent: {
      title: 'Чем мы отличаемся',
      subtitle: 'Не просто детский центр',
      competitors: {
        title: 'Обычные центры',
        features: [
          'Только игровая зона',
          'Нет ресторана',
          'Базовая анимация',
          'Ограниченный доход',
        ],
      },
      us: {
        title: 'KidsMafia',
        features: [
          'Парк + Ресторан + Events',
          'Полный цикл мероприятий',
          'Профессиональная команда',
          'Множество источников дохода',
        ],
      },
    },
    partnershipModel: {
      title: 'Партнёрская модель',
      subtitle: 'Гибкие варианты входа',
      options: [
        'Запуск самостоятельно',
        'Запуск с партнёром',
      ],
      detailsTitle: 'Преимущества модели',
      details: [
        'Модель адаптируется под ваши возможности',
        'Можно работать в разных странах',
        'Возможна региональная эксклюзивность',
        'Поддержка на всех этапах',
      ],
    },
    expandedScenario: {
      title: 'Расширенный финансовый сценарий',
      subtitle: 'Формат Premium+',
      investment: 'Инвестиции: ~300 000 €',
      revenue: 'Высокая прибыльность',
      detailsTitle: 'Что входит',
      details: [
        'Площадь 800+ м²',
        'Расширенная event-зона',
        'Дополнительные активности',
        'Мастер-классы постоянно',
        'Выездные мероприятия',
        'Полная загрузка 40-50 событий/мес',
      ],
      payback: 'Окупаемость: ~23 месяца',
    },
    cta: {
      tag: 'Присоединяйтесь к семье KidsMafia',
      title: 'Откройте KidsMafia',
      title2: 'в своём городе',
      subtitle: 'Получите подробную информацию о франшизе и условиях партнёрства.',
      call: 'Позвонить',
      telegram: 'Написать в Telegram',
      ready: 'Готовы начать?',
      contact: 'Свяжитесь с нами',
    },
    footer: {
      tagline: 'Семейный event-бизнес нового уровня',
      phone_label: 'Телефон',
      telegram_label: 'Telegram',
      email_label: 'Email',
      location: 'Международная франшиза',
      rights: '© 2025 KidsMafia Franchise. Все права защищены.',
      company: 'KIDS MAFIA SL',
      address: 'Calle Puebla de Valverde 4, 46014 Valencia, Spain',
      nif: 'NIF: B22815575',
      legal_links: 'Правовая информация',
      privacy: 'Политика конфиденциальности',
      cookies: 'Политика Cookie',
      terms: 'Условия использования',
      legal_notice: 'Правовая информация',
    },
    company: {
      name: 'KIDS MAFIA SL',
      address: 'Calle Puebla de Valverde 4',
      city: '46014 Valencia',
      country: 'Spain',
      nif: 'B22815575',
      email: 'kidsmafia.vlc@gmail.com',
      phone: '+34 624 586 917',
    },
    legal: {
      privacy_title: 'Политика конфиденциальности',
      cookies_title: 'Политика Cookie',
      terms_title: 'Условия использования',
      legal_notice_title: 'Правовая информация',
    },
    cookies: {
      banner_text: 'Мы используем cookies для улучшения работы сайта. Продолжая использовать сайт, вы соглашаетесь с использованием cookies.',
      accept: 'Принять',
      reject: 'Отклонить',
      learn_more: 'Узнать детали',
    },
  },

  es: {
    nav: {
      about: 'Sobre nosotros',
      format: 'Formato',
      finances: 'Finanzas',
      investments: 'Inversiones',
      gallery: 'Galería',
      contacts: 'Contactar ahora',
      call: 'Contactar',
    },
    hero: {
      tag: 'Oportunidad de inversión',
      title_line1: 'Negocio estable',
      title_line2: 'que crece',
      brand: 'KidsMafia',
      subtitle: 'Modelo listo de negocio de eventos familiar con recuperación en 23–25 meses',
      metric1_label: 'Margen hasta',
      metric1_value: 40,
      metric1_suffix: '%',
      metric1_unit: '',
      metric2_label: 'Recuperación desde',
      metric2_value: 23,
      metric2_suffix: ' meses',
      metric3_label: 'Inversión desde',
      metric3_value: 150000,
      metric3_suffix: ' €',
      cta_call: 'Contactar',
      cta_presentation: 'Obtener presentación',
      cta_telegram: 'Escribir por Telegram',
      scroll_hint: 'Saber más',
    },
    about: {
      title: '¿Qué es KidsMafia?',
      desc1: 'KidsMafia es un espacio de eventos familiar de ciclo completo.',
      desc2: 'Un espacio donde los niños celebran, los padres descansan y el equipo organiza completamente el evento.',
      features: [
        { title: 'Parque infantil', desc: 'Atracciones modernas y zonas de juego' },
        { title: 'Zona de restaurante', desc: 'Restaurante completo para toda la familia' },
        { title: 'Espacio de eventos', desc: 'Espacio para todo tipo de celebraciones' },
        { title: 'Animación profesional', desc: 'Animadores y programas de espectáculo' },
        { title: 'Eventos llave en mano', desc: 'Organización completa de principio a fin' },
        { title: 'Cuidado de niños', desc: 'Cuidado y supervisión profesional' },
        { title: 'Formatos de banquete', desc: 'Banquetes y eventos corporativos' },
        { title: 'Eventos a domicilio', desc: 'Organización de eventos fuera del espacio' },
      ],
    },
    format: {
      title: 'Sistema único de eventos familiares',
      subtitle: 'Cinco áreas clave dentro de un mismo espacio',
      items: [
        { title: 'Parque de atracciones', desc: 'Atracciones modernas, toboganes, camas elásticas, zonas blandas' },
        { title: 'Zona de restaurante', desc: 'Restaurante completo con menú infantil y opciones de banquete' },
        { title: 'Espacio de eventos', desc: 'Salas transformables para cualquier formato de evento' },
        { title: 'Organización de eventos', desc: 'Fiestas llave en mano: decoración, animación, foto, catering' },
        { title: 'Servicio de cuidado infantil', desc: 'Educadores y animadores profesionales' },
      ],
    },
    franchiseFormats: {
      title: 'Formatos de franquicia',
      subtitle: 'Tres formatos de entrada al negocio para diferentes presupuestos',
      standard: {
        type: 'STANDARD',
        area: '250–300 m²',
        label1: 'Eventos al mes',
        val1: '20–40',
        label2: 'Facturación',
        val2: '18 000 – 40 000 €',
        label3: 'Margen',
        val3: '25–35%',
        badge: 'Inicio en el negocio',
        desc: 'Incluye parque, restaurante y zona de eventos',
      },
      recommended: {
        type: 'RECOMENDADO',
        area: '300–600 m²',
        label1: 'Eventos al mes',
        val1: '30–50',
        label2: 'Facturación',
        val2: '35 000 – 50 000 €',
        label3: 'Margen',
        val3: '30–40%',
        badge: 'Elección óptima',
        desc: 'Zona de eventos ampliada y más oportunidades',
      },
      premium: {
        type: 'PREMIUM',
        area: '600+ m²',
        label1: 'Eventos al mes',
        val1: '40–70',
        label2: 'Facturación',
        val2: '50 000 – 70 000 €',
        label3: 'Margen',
        val3: '35–45%',
        badge: 'Formato a escala',
        desc: 'Complejo completo con área de talleres',
      },
    },
    investments: {
      title: 'Inversiones para apertura',
      subtitle: 'Estructura de costes transparente',
      items: [
        { label: 'Traspaso y licencias', value: '25 000 – 60 000 €', icon: 'FileCheck' },
        { label: 'Reformas y acabados', value: '20 000 – 40 000 €', icon: 'Wrench' },
        { label: 'Equipamiento y decoración', value: '15 000 – 30 000 €', icon: 'Package' },
        { label: 'Capital circulante', value: '40 000 – 50 000 €', icon: 'Banknote' },
      ],
      total_label: 'Inversión total',
      total_value: 'desde 150 000 €',
      total_note: 'Paquete completo de apoyo en la apertura',
    },
    franchiseIncludes: {
      title: 'Qué incluye la cuota de franquicia',
      subtitle: 'Lanzamiento completo del negocio llave en mano',
      priceLabel: 'Cuota de franquicia',
      priceValue: '40 000 €',
      priceNote: 'Cuota única de franquicia para todos los formatos. El formato afecta el volumen de inversión y la escala del proyecto.',
      paymentsTitle: 'Pagos regulares',
      royalty: {
        label: 'Royalty',
        year1: '1er año — 5%',
        year2plus: 'desde el 2º año — 6–8%',
      },
      marketingFee: {
        label: 'Cuota de marketing',
        value: '1–2%',
      },
      block1: {
        title: 'Base del negocio',
        items: [
          'Derecho de uso de la marca KidsMafia',
          'Modelo de negocio listo',
          'Modelo financiero con cálculos',
          'Plan de inversión de lanzamiento',
          'Guía de diseño y estándares de decoración',
        ],
      },
      block2: {
        title: 'Sistema operativo',
        items: [
          'Reglamentos operativos',
          'Estándares de servicio',
          'Estándares de animación',
          'Timing de eventos',
          'Checklists de control diario',
        ],
      },
      block3: {
        title: 'Cocina y bar',
        items: [
          'Cartas tecnológicas de cocina',
          'Lanzamiento de cocina llave en mano',
          'Formación de menú',
          'Formación de menú de bar',
          'Cálculo de coste',
        ],
      },
      block4: {
        title: 'Lanzamiento llave en mano',
        items: [
          'Lanzamiento completo del proyecto',
          'Apoyo en todas las etapas',
          'Guiones de eventos',
          'Formatos de celebraciones',
          'Programas adicionales',
        ],
      },
      revenueTitle: 'Fuentes adicionales de ingresos',
      revenueSources: [
        'Cumpleaños',
        'Restaurante',
        'Zona de juegos',
        'Talleres',
        'Quests',
        'Fiestas temáticas',
        'Eventos a domicilio',
        'Programas de temporada',
      ],
    },
    revenue: {
      title: 'Cómo genera ingresos el negocio',
      subtitle: 'Múltiples fuentes de ingresos dentro de un mismo espacio',
      items: [
        { label: 'Cumpleaños', icon: 'Gift' },
        { label: 'Restaurante', icon: 'Utensils' },
        { label: 'Visita libre', icon: 'DoorOpen' },
        { label: 'Talleres', icon: 'Palette' },
        { label: 'Quests', icon: 'Search' },
        { label: 'Fiestas temáticas', icon: 'PartyPopper' },
        { label: 'Eventos a domicilio', icon: 'Car' },
        { label: 'Programas de temporada', icon: 'Calendar' },
        { label: 'Club de fin de semana', icon: 'Coffee' },
        { label: 'Guardería a tiempo parcial', icon: 'Baby' },
        { label: 'Servicios de niñera', icon: 'Heart' },
        { label: 'Encuentros educativos', icon: 'BookOpen' },
      ],
    },
    financial: {
      title: 'Modelo financiero',
      subtitle: 'Números claros — negocio transparente',
      metrics: [
        { label: 'Ticket mínimo por fiesta', value: '400 €', num: 400 },
        { label: 'Ticket medio', value: '700 €', num: 700 },
        { label: 'Facturación media / mes', value: '25 000 €', num: 25000 },
        { label: 'Beneficio neto', value: '≈ 6 000 €', num: 6000 },
      ],
      note1: 'Para cubrir los gastos fijos bastan unos 10 eventos al mes.',
      note2: 'La carga media es de 20 a 35 eventos.',
      detailsTitle: 'Desglose detallado',
      revenueBreakdown: {
        title: 'Estructura de ingresos',
        items: [
          { label: 'Cumpleaños', percent: '60%' },
          { label: 'Restaurante', percent: '20%' },
          { label: 'Zona de juegos', percent: '20%' },
        ],
      },
      expensesBreakdown: {
        title: 'Estructura de gastos',
        fixed: [
          'Alquiler del local',
          'Salarios del personal',
          'Servicios públicos',
          'Royalty',
        ],
        variable: [
          'Productos (restaurante)',
          'Materiales consumibles',
          'Publicidad',
        ],
      },
      paybackTitle: 'Período de recuperación',
      paybackValue: '≈ 25 meses',
    },
    scaling: {
      title: 'Escalado del negocio',
      subtitle: 'De un punto a una red nacional',
      items: [
        { title: 'Un local', desc: 'Tu primer paso en el negocio familiar', num: '01' },
        { title: 'Varios locales en la ciudad', desc: 'Expansión de presencia y cuota de mercado', num: '02' },
        { title: 'Exclusiva de ciudad', desc: 'Derecho exclusivo a operar en la ciudad', num: '03' },
        { title: 'Exclusiva regional', desc: 'Cobertura regional y gestión de red', num: '04' },
        { title: 'Master-franquicia nacional', desc: 'Gestión de toda la red nacional', num: '05' },
      ],
    },
    gallery: {
      title: 'Galería',
      subtitle: 'La atmósfera que vende',
    },
    investorMarket: {
      title: 'Por qué los inversores entran en este mercado',
      subtitle: 'Demanda estable y resistencia a las crisis',
      reasons: [
        'Los niños nacen constantemente',
        'Los cumpleaños no se cancelan',
        'Los padres siguen gastando en niños incluso en crisis',
        'El ocio familiar crece constantemente',
      ],
      antiCrisis: {
        title: 'Resistencia del mercado a las crisis',
        reduce: 'En tiempos difíciles la gente reduce',
        reduceList: [
          'Viajes caros',
          'Compras de lujo',
          'Grandes gastos no esenciales',
        ],
        continue: 'Pero continúan gastando en',
        continueList: [
          'Cumpleaños de los niños',
          'Ocio familiar',
          'Entretenimiento para el niño',
          'Emociones y celebraciones',
        ],
      },
      investorGets: {
        title: 'Lo que obtiene el inversor',
        list: [
          'Participación en modelo rentable',
          'Sistema de negocio transparente',
          'Participación en beneficios',
          'Crecimiento del valor del activo',
          'Escenario de salida claro',
        ],
      },
    },
    investorExit: {
      title: 'Estrategia de salida del inversor',
      subtitle: 'Opciones flexibles de monetización de inversiones',
      options: [
        'Vender el local como negocio listo',
        'Vender la franquicia',
        'Vender la participación',
      ],
      valuation: {
        label: 'Valoración media de un local activo',
        value: '≈ 250 000 €',
      },
      explanation: 'Esto significa que el inversor puede recuperar los fondos invertidos y ganar con el crecimiento del valor del negocio.',
    },
    franchiseGoals: {
      title: 'Objetivo de la franquicia',
      subtitle: 'Desarrollo global de la red',
      goals: [
        'Escalado en países de la UE',
        'Entrada en mercados de EE. UU. y Asia',
        'Creación de una red internacional',
      ],
      detailsTitle: 'Detalles de la estrategia',
      detailsList: [
        'Adaptación del modelo a los mercados locales',
        'Búsqueda de master-franquiciados regionales',
        'Expansión sistemática de la presencia',
        'Construcción de una marca reconocible',
      ],
    },
    partnerRequirements: {
      title: 'Requisitos para el socio',
      visibleTitle: 'Requisitos mínimos',
      capital: 'Capital: desde 120 000 €',
      detailsTitle: 'Condiciones importantes',
      requirements: [
        'Cumplimiento de los estándares de la marca',
        'Trabajo según el sistema establecido',
        'Experiencia empresarial no obligatoria',
        'Deseo de desarrollar el proyecto',
        'Disposición para invertir en formación',
      ],
    },
    whyDifferent: {
      title: 'En qué nos diferenciamos',
      subtitle: 'No solo un centro infantil',
      competitors: {
        title: 'Centros comunes',
        features: [
          'Solo zona de juegos',
          'Sin restaurante',
          'Animación básica',
          'Ingresos limitados',
        ],
      },
      us: {
        title: 'KidsMafia',
        features: [
          'Parque + Restaurante + Eventos',
          'Ciclo completo de eventos',
          'Equipo profesional',
          'Múltiples fuentes de ingresos',
        ],
      },
    },
    partnershipModel: {
      title: 'Modelo de asociación',
      subtitle: 'Opciones flexibles de entrada',
      options: [
        'Lanzamiento independiente',
        'Lanzamiento con socio',
      ],
      detailsTitle: 'Ventajas del modelo',
      details: [
        'El modelo se adapta a tus posibilidades',
        'Posibilidad de trabajar en diferentes países',
        'Posibilidad de exclusividad regional',
        'Apoyo en todas las etapas',
      ],
    },
    expandedScenario: {
      title: 'Escenario financiero ampliado',
      subtitle: 'Formato Premium+',
      investment: 'Inversiones: ~300 000 €',
      revenue: 'Alta rentabilidad',
      detailsTitle: 'Qué incluye',
      details: [
        'Superficie 800+ m²',
        'Zona de eventos ampliada',
        'Actividades adicionales',
        'Talleres permanentes',
        'Eventos a domicilio',
        'Carga completa 40-50 eventos/mes',
      ],
      payback: 'Recuperación: ~23 meses',
    },
    cta: {
      tag: 'Únase a la familia KidsMafia',
      title: 'Abra KidsMafia',
      title2: 'en su ciudad',
      subtitle: 'Obtenga información detallada sobre la franquicia y las condiciones de asociación.',
      call: 'Llamar',
      telegram: 'Escribir por Telegram',
      ready: '¿Listo para empezar?',
      contact: 'Contáctenos',
    },
    footer: {
      tagline: 'Negocio de eventos familiares de nuevo nivel',
      phone_label: 'Teléfono',
      telegram_label: 'Telegram',
      email_label: 'Email',
      location: 'Franquicia internacional',
      rights: '© 2025 KidsMafia Franchise. Todos los derechos reservados.',
      company: 'KIDS MAFIA SL',
      address: 'Calle Puebla de Valverde 4, 46014 Valencia, Spain',
      nif: 'NIF: B22815575',
      legal_links: 'Información legal',
      privacy: 'Política de privacidad',
      cookies: 'Política de cookies',
      terms: 'Términos de uso',
      legal_notice: 'Aviso legal',
    },
    company: {
      name: 'KIDS MAFIA SL',
      address: 'Calle Puebla de Valverde 4',
      city: '46014 Valencia',
      country: 'Spain',
      nif: 'B22815575',
      email: 'kidsmafia.vlc@gmail.com',
      phone: '+34 624 586 917',
    },
    legal: {
      privacy_title: 'Política de privacidad',
      cookies_title: 'Política de cookies',
      terms_title: 'Términos de uso',
      legal_notice_title: 'Aviso legal',
    },
    cookies: {
      banner_text: 'Utilizamos cookies para mejorar el funcionamiento del sitio. Al seguir utilizando el sitio, acepta el uso de cookies.',
      accept: 'Aceptar',
      reject: 'Rechazar',
      learn_more: 'Más información',
    },
  },
};
